import BreadcrumbItem from "flowbite-react/lib/esm/components/Breadcrumb/BreadcrumbItem";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { StrategyEntityItemType } from "../../services/strategyMap";
import store from "../../redux/store";
import { resetTimelineState } from "../../redux/slices/timeline";
import { resetRoadmap, setSingleRoadmap } from "../../redux/slices/roadmap";

export function PreviousBreadCrumb() {
  /* Check for Previous Page */

  const { previousRoute, currentRoute } = useSelector((state: any) => state.navigationInfo);
  
  const [label, setLabel] = useState("")
  const [url, setUrl] = useState<string | null>(null);

  const state = useSelector((t: any) => t.strategyMapView.currentData) as StrategyEntityItemType;
  const location = useLocation();

  const [historyCrumbs, setHistoryCrumbs] = useState<any[]>([]);

  useEffect(() => {
    // Parse history from URL
    const searchParams = new URLSearchParams(location.search);
    const historyParam = searchParams.get("history");
    if (historyParam) {
      try {
        const parsedHistory = JSON.parse(historyParam);
        if (Array.isArray(parsedHistory)) {
          setHistoryCrumbs(parsedHistory);
          return; // Skip existing logic if history param exists
        }
      } catch (e) {
        console.error("Failed to parse history param", e);
      }
    }

    // Fallback to existing logic
    if(previousRoute) {
      const splittedUrl = previousRoute.split('/');
      const lastUrl = splittedUrl[1];

       setUrl(previousRoute);

       if (lastUrl == "strategymaps") setLabel(state?.name ?? "");
       if (lastUrl == "projects") {
      
        setLabel("Work Items");
       }
       if (lastUrl == "roadmaps") {
        
        setLabel("Work Items");
       }


    } else {
      setUrl(null);
    }
  }, [previousRoute, location.search, state]);



  const isPrevStrategyMap = previousRoute && (previousRoute.split("/")?.[1] ?? null) == "strategymaps";


  const isProjects = currentRoute && (currentRoute.split("/")?.[1] ?? null) == "projects";
  const isRoadmaps = currentRoute && (currentRoute.split("/")?.[1] ?? null) == "roadmaps";

  const isNoHistory = (isProjects || isRoadmaps) && !url;

  useEffect(()=>{
    if(isNoHistory) {
      //  store.dispatch(resetTimelineState());
      //  store.dispatch(resetRoadmap());
      //  store.dispatch(setSingleRoadmap({} as any));
    }
  }, [isNoHistory])


  
  if (historyCrumbs.length > 0) {
    return (
      <>
        {historyCrumbs.map((crumb, index) => (
          <BreadcrumbItem key={index}>
            <Link to={crumb.url} className="breadcrumb-link">
              {crumb.name}
            </Link>
          </BreadcrumbItem>
        ))}
      </>
    );
  }

  if (isProjects || isRoadmaps) return (
    <>
      <BreadcrumbItem>
        <Link to={"/workitems"} className="breadcrumb-link">
          Work Items
        </Link>
      </BreadcrumbItem>
    </>
  );


  if (!url && !isNoHistory) return <></>;

  return (
    <>
        {isPrevStrategyMap && (
            <BreadcrumbItem>
          <Link to={"/strategymap"} className="breadcrumb-link">
            Strategy Maps
          </Link>
            </BreadcrumbItem>
        )}
        {isNoHistory && (
            <BreadcrumbItem>
          <Link to={"/workitems"} className="breadcrumb-link">
            Work Items
          </Link>
            </BreadcrumbItem>
        )}

        {url &&
      <BreadcrumbItem>
        <Link to={url} className="breadcrumb-link">
          {label}
        </Link>
      </BreadcrumbItem>
        }
    </>
  );
}